<template>
  <v-app>
    <v-main :style="$vuetify.theme.dark ? 'background: #1E1E1E;' : ''">
      <v-fab-transition>
        <v-btn
          v-show="fab"
          :color="$vuetify.theme.dark ? '' : 'white'"
          class="green--text"
          fixed
          right
          top
          fab
          @click.stop="showHelp"
        >
          <v-icon>mdi-account-question</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-dialog v-model="help" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="secondary" dense class="elevation-0">
            <v-btn icon dark @click="help = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Help</v-toolbar-title>
          </v-toolbar>
          <v-list three-line subheader>
            <v-subheader>Need Help?</v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Call us on:</v-list-item-title>
                <v-list-item-subtitle><v-btn dark color="green" :href="variables['HELP_PHONE_LINK']"><v-icon left>mdi-phone</v-icon> {{ variables['HELP_PHONE_TEXT'] }}</v-btn></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Send us a message:</v-list-item-title>
                <v-list-item-subtitle><v-btn dark color="green" href="mailto:support@fixpert.net"><v-icon left>mdi-email</v-icon> support@fixpert.net</v-btn></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <InquiryForm/>
        </v-card>
      </v-dialog>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
// @ is an alias to /src
// import logo from '@/assets/logo.png'

import InquiryForm from '@/components/InquiryForm'

import { mapGetters } from 'vuex'

export default {
  name: 'BlankLayout',
  components: {
    InquiryForm
  },
  data () {
    return {
      help: false,
      fab: false,
      snackbar: false,
      email: '',
      text: ''
    }
  },
  computed: {
    ...mapGetters(['variables'])
  },
  methods: {
    showHelp () {
      this.help = true
    }
  },
  created () {
    setTimeout(() => {
      this.fab = true
    }, 500)
  }
}
</script>

<style scoped>
.v-overlay--active {
  pointer-events: unset;
}
</style>
